// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.no-auth-upload {
  margin: 0 auto;
  width: 30%;
  margin-top: 30px;
}

.progress-cell {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.progress-container {
  background-color: #f3f3f3;
  border-radius: 4px;
  height: 10px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.progress-filler {
  background-color: #33b8d4;
  height: 100%;
  border-radius: 4px;
  transition: width 0.3s ease-in-out;
}

.progress-text {
  padding-left: 10px;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/components/noAuthUpload/components/style.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB","sourcesContent":[".no-auth-upload {\n  margin: 0 auto;\n  width: 30%;\n  margin-top: 30px;\n}\n\n.progress-cell {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n.progress-container {\n  background-color: #f3f3f3;\n  border-radius: 4px;\n  height: 10px;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.progress-filler {\n  background-color: #33b8d4;\n  height: 100%;\n  border-radius: 4px;\n  transition: width 0.3s ease-in-out;\n}\n\n.progress-text {\n  padding-left: 10px;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
